import * as React from "react";
import { Navigate, Route, Routes, useParams } from "react-router-dom";
import { useAppDispatch } from "../../store/hooks";
import { setTitleName } from "../../store/titleSlice";
import { IncorrectItem } from "../../components/generic/IncorrectItem/incorrectItem";
import { Loader } from "../../components/layout/loader";
import { BasePathContext, useBasePath } from "../../reactContexts/basePathContext";
import { Summary } from "./summary";
import { useGetQuotaQuery } from "../../store/api/quotaApi";
import { SingleNavMenu } from "../../components/antd/layout/singleNavMenu";
import { forPage } from "../identity/useNavMenu";
import { ContentLayout } from "../../components/layout/contentLayout";
import { QuotaDetailHeader } from "./header";

type RouteParams = "org" | "idName";
export const QuotaDetail: React.FC = () => {
  const basePath = useBasePath("/quota/:quota/*");
  const dispatch = useAppDispatch();

  const { org: orgName, idName } = useParams<RouteParams>();
  const id = React.useMemo<string | null>(() => {
    if (!idName || idName.split(":s:").length < 2 || idName.split(":s:")[1].length < 1) {
      return null;
    }
    return idName.split(":s:")[0];
  }, [idName]);

  const selfLink = `/org/${orgName}/quota/${id}`;
  const { data: quota, isLoading, isError } = useGetQuotaQuery(selfLink || "", {
    skip: !selfLink,
    refetchOnMountOrArgChange: true,
  });

  // Set document title from quota description
  React.useEffect(() => {
    if (quota?.description) {
      dispatch(setTitleName(quota.description));
    }
    return () => {
      dispatch(setTitleName(null));
    };
  }, [quota?.description]);

  if (isLoading) {
    return <Loader fullScreen />;
  }

  if (isError || !quota || !id) {
    return <IncorrectItem kind={"quota"} canCreate={false} />;
  }

  return (
    <BasePathContext.Provider value={basePath}>
        <QuotaDetailHeader quota={quota} />
        <ContentLayout
          nav={
            <SingleNavMenu
              useDetailHeader={true}
              links={[forPage("/info").toLinkSection("Summary", "summary")]}
              pagesWithScrolls={["info"]}
            />
          }
          content={
            <Routes>
              <Route index element={<Navigate to={`${basePath}/info/summary`} replace />} />
              <Route
                path={`info/*`}
                element={
                  <div className="cpln-cards-container flex flex-col gap-4 relative">
                    <Summary quota={quota} />
                  </div>
                }
              />
              <Route path={`*`} element={<Navigate to={`${basePath}/info/summary`} replace />} />
            </Routes>
          }
        />
    </BasePathContext.Provider>
  );
};
